import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoTourism = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Tourism</title>
    <circle cx={16} cy={15.974} r={12} stroke="currentColor" strokeWidth={2} />
    <path
      d="m4.98 11.883 2.173 1.491a6.689 6.689 0 0 1 2.197 2.523l.646 1.293c.246.492.649.888 1.145 1.125l.432.207a1.864 1.864 0 0 1 .82 2.591l-.304.546a5.949 5.949 0 0 1-.636.919l-.456.542c-.414.492-.862.954-1.342 1.382l-.718.64M17.21 27.3c-.847-4.114 3.442-2.344 3.596-5.754.163-3.597 4.43-7.702 7.194-5.755M25 9c-1.516 2.172-8.186 4.927-10.668 3.194-2.482-1.733 0-3.597-1.439-7.194"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoTourism;
